import { render, staticRenderFns } from "./newChallenges.vue?vue&type=template&id=04ddae56&scoped=true"
import script from "./newChallenges.vue?vue&type=script&lang=js"
export * from "./newChallenges.vue?vue&type=script&lang=js"
import style0 from "./newChallenges.vue?vue&type=style&index=0&id=04ddae56&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04ddae56",
  null
  
)

export default component.exports